var _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _g2, _path2, _rect6, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMatchingTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 120,
    viewBox: "0 0 126 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 107.6C87.0097 107.6 108.5 86.1098 108.5 59.6001C108.5 33.0904 87.0097 11.6001 60.5 11.6001C33.9903 11.6001 12.5 33.0904 12.5 59.6001C12.5 86.1098 33.9903 107.6 60.5 107.6Z",
    fill: "#F7F8FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_445_42250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1001 29.4228C36.1001 27.2137 37.891 25.4229 40.1001 25.4229H81.9149C84.1241 25.4229 85.9149 27.2137 85.9149 29.4229V83.4344C85.9149 85.6435 84.1241 87.4344 81.9149 87.4344H40.1001C37.891 87.4344 36.1001 85.6435 36.1001 83.4344V29.4228Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 33.4229,
    width: 20,
    height: 3.92,
    rx: 1.96,
    fill: "#27293F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 44.543,
    width: 40,
    height: 3.92,
    rx: 1.96,
    fill: "#E1E3F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 55.6626,
    width: 40,
    height: 3.92,
    rx: 1.96,
    fill: "#E1E3F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 66.7827,
    width: 40,
    height: 3.92,
    rx: 1.96,
    fill: "#E1E3F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 77.9028,
    width: 40,
    height: 3.92,
    rx: 1.96,
    fill: "#E1E3F4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_445_42250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.76 18.5693H91.7276C90.6078 18.5693 89.7 19.5247 89.7 20.7033V32.5909C89.7 33.7695 90.6078 34.7249 91.7276 34.7249H115.76C116.88 34.7249 117.788 33.7695 117.788 32.5909V20.7033C117.788 19.5247 116.88 18.5693 115.76 18.5693Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7001 29.1999C97.0255 29.1999 98.1 28.1254 98.1 26.7999C98.1 25.4744 97.0255 24.3999 95.7001 24.3999C94.3746 24.3999 93.3 25.4744 93.3 26.7999C93.3 28.1254 94.3746 29.1999 95.7001 29.1999Z",
    fill: "#E1E3F4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 24.3999,
    width: 12.8,
    height: 4.8,
    rx: 2.4,
    fill: "#E1E3F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5439 40.2256C88.3511 40.2256 99.5439 51.4185 99.5439 65.2256C99.5439 70.6158 97.8379 75.6075 94.9365 79.6904L110.646 94.6865L104.742 101.536L88.4609 85.9951C84.4827 88.6661 79.6957 90.2256 74.5439 90.2256C60.7368 90.2256 49.5439 79.0327 49.5439 65.2256C49.5439 51.4185 60.7368 40.2256 74.5439 40.2256ZM74.7021 44.0605C63.0129 44.0605 53.5371 53.5363 53.5371 65.2256C53.5372 76.9148 63.0129 86.3906 74.7021 86.3906C86.3913 86.3906 95.8671 76.9148 95.8672 65.2256C95.8672 53.5363 86.3914 44.0606 74.7021 44.0605Z",
    fill: "#E1E3F4"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 49.6999,
    y: 40.4001,
    width: 50.0001,
    height: 49.6002
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.6px)",
      clipPath: "url(#bgblur_0_445_42250_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 3.2,
    d: "M74.6999 86.8001C86.7397 86.8001 96.4999 77.1294 96.4999 65.2001C96.4999 53.2707 86.7397 43.6001 74.6999 43.6001C62.6601 43.6001 52.8999 53.2707 52.8999 65.2001C52.8999 77.1294 62.6601 86.8001 74.6999 86.8001Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4693 65.2002L83.7449 59.945C84.2391 59.4252 84.5099 58.7342 84.4997 58.019C84.4895 57.3038 84.1991 56.6208 83.6903 56.115C83.1814 55.6093 82.4942 55.3207 81.7746 55.3105C81.0551 55.3004 80.3599 55.5696 79.8368 56.0608L74.5495 61.3159L69.2739 56.0608C69.02 55.7938 68.7149 55.58 68.3765 55.4323C68.0381 55.2845 67.6733 55.2057 67.3037 55.2005C66.9341 55.1953 66.5672 55.2638 66.2247 55.402C65.8822 55.5401 65.5711 55.7452 65.3097 56.005C65.0483 56.2648 64.842 56.574 64.703 56.9144C64.564 57.2548 64.495 57.6195 64.5003 57.9868C64.5055 58.3541 64.5848 58.7167 64.7335 59.0531C64.8822 59.3894 65.0972 59.6927 65.3659 59.945L70.6503 65.2002L65.3659 70.4554C65.0972 70.7077 64.8822 71.011 64.7335 71.3473C64.5848 71.6837 64.5055 72.0462 64.5003 72.4136C64.495 72.7809 64.564 73.1456 64.703 73.486C64.842 73.8264 65.0483 74.1356 65.3097 74.3954C65.5711 74.6552 65.8822 74.8602 66.2247 74.9984C66.5672 75.1366 66.9341 75.2051 67.3037 75.1999C67.6733 75.1947 68.0381 75.1159 68.3765 74.9681C68.7149 74.8204 69.02 74.6066 69.2739 74.3396L74.5613 69.0844L79.8486 74.3396C80.3767 74.8019 81.0622 75.0466 81.7654 75.0239C82.4687 75.0013 83.1368 74.7129 83.6336 74.2177C84.1304 73.7224 84.4185 73.0575 84.4392 72.3584C84.4599 71.6594 84.2116 70.9788 83.7449 70.4554L78.4693 65.2002Z",
    fill: "#9396B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.741 101.537L110.645 94.687L111.534 95.5359C112.397 96.3596 112.913 97.5102 112.97 98.7347C113.027 99.9591 112.619 101.157 111.836 102.065C111.054 102.973 109.96 103.517 108.797 103.577C107.633 103.636 106.495 103.207 105.632 102.383L104.743 101.535L104.741 101.537Z",
    fill: "#C4C6DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0258 36.4689C23.0183 35.8985 22.9467 35.3231 22.8036 34.7439C22.3017 32.711 20.0626 31.406 17.6794 31.0991C15.2971 30.7923 12.8198 31.4905 11.865 33.2588C11.3188 34.2698 11.2435 35.1412 11.4667 35.8758C11.6889 36.6065 12.2162 37.2124 12.9318 37.6844C14.927 38.9993 18.4214 39.2678 20.0155 38.718C20.7528 38.4633 21.4731 38.1565 22.1746 37.8054C21.7735 40.1038 20.2791 42.2812 18.2848 44.2432C13.9506 48.5075 7.22472 51.7441 3.56187 52.9341C3.36508 52.998 3.25584 53.2164 3.31705 53.4219C3.37825 53.6274 3.58728 53.7425 3.78408 53.6786C7.51943 52.465 14.3762 49.1596 18.7961 44.8107C21.0795 42.5644 22.7066 40.0359 22.9844 37.3776C28.1463 34.497 32.3854 29.2709 36.0096 24.8728C36.1443 24.7105 36.1264 24.4637 35.9701 24.323C35.8138 24.1834 35.5784 24.2011 35.4437 24.3643C31.9673 28.5824 27.9325 33.6001 23.0258 36.4689ZM22.2754 36.8868C22.3036 36.2456 22.2433 35.5946 22.0804 34.9376C21.6464 33.1782 19.6511 32.1377 17.588 31.8721C16.3235 31.7099 15.0231 31.8436 14.0034 32.3196C13.3621 32.6186 12.8339 33.0523 12.5156 33.6424C12.0975 34.4164 12.0071 35.0782 12.1785 35.6398C12.3499 36.2053 12.7755 36.6596 13.3301 37.0245C15.1484 38.2234 18.33 38.4781 19.781 37.9775C20.637 37.6825 21.4675 37.3146 22.2754 36.8868Z",
    fill: "#383B56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 73.6002,
    r: 2.4,
    fill: "#6F00FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8538 90.158C24.2821 89.9974 24.7329 89.7839 25.0804 89.4749C25.4932 89.1078 25.6611 88.6351 25.7739 88.1374C25.9186 87.4981 25.9764 86.817 26.1519 86.1766C26.2169 85.9388 26.342 85.8489 26.3956 85.809C26.5313 85.7083 26.6684 85.6813 26.7974 85.6914C26.9502 85.7031 27.1602 85.764 27.2983 86.0336C27.318 86.0722 27.3436 86.131 27.3608 86.2116C27.3734 86.2707 27.3815 86.4554 27.3948 86.5315C27.428 86.7191 27.4558 86.9067 27.4819 87.0952C27.5688 87.7229 27.6188 88.2561 27.8932 88.8327C28.2657 89.6156 28.6388 90.0945 29.1449 90.3067C29.6343 90.5119 30.2194 90.4733 30.967 90.3124C31.0381 90.2943 31.1085 90.2787 31.1782 90.266C31.5078 90.2054 31.8228 90.4331 31.8876 90.7787C31.9523 91.124 31.7428 91.4605 31.4162 91.5364C31.348 91.5522 31.2808 91.5673 31.2143 91.581C30.2041 91.8442 29.0346 92.7835 28.355 93.606C28.1455 93.8596 27.8388 94.5686 27.526 95.021C27.2951 95.3546 27.0356 95.5746 26.8178 95.6523C26.6718 95.7046 26.5487 95.6966 26.4471 95.6702C26.2994 95.6318 26.1768 95.5476 26.0828 95.4137C26.0316 95.3404 25.9841 95.2422 25.9614 95.1168C25.9506 95.0564 25.9494 94.9031 25.9496 94.8337C25.8859 94.6029 25.8078 94.3775 25.751 94.1446C25.6153 93.5889 25.3492 93.2371 25.0332 92.7724C24.7375 92.3374 24.42 92.0641 23.9545 91.846C23.894 91.8305 23.4054 91.7046 23.2328 91.6323C22.9807 91.5263 22.8606 91.3489 22.817 91.2533C22.743 91.0911 22.7353 90.9494 22.7501 90.8313C22.772 90.657 22.8463 90.5077 22.9783 90.3873C23.06 90.3124 23.1821 90.2396 23.3455 90.2041C23.4718 90.1764 23.8068 90.1604 23.8538 90.158ZM26.7203 89.2524C26.743 89.3055 26.7671 89.3588 26.7927 89.4127C27.3382 90.5593 27.9481 91.1994 28.6895 91.51L28.7144 91.5201C28.2184 91.9077 27.7694 92.3408 27.4263 92.7561C27.285 92.927 27.0979 93.2822 26.8958 93.6464C26.7122 93.0182 26.4119 92.5742 26.0343 92.0185C25.7458 91.5945 25.4435 91.2753 25.0721 91.0152C25.3603 90.8595 25.6353 90.6772 25.8748 90.4642C26.2735 90.1096 26.5372 89.6987 26.7203 89.2524Z",
    fill: "#6F00FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_445_42250",
    x: 24.1001,
    y: 21.4229,
    width: 73.8149,
    height: 86.0117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_445_42250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_445_42250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_445_42250",
    x: 86.9,
    y: 14.9693,
    width: 38.4876,
    height: 26.5558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.4,
    dy: 1.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_445_42250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_445_42250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_445_42250_clip_path",
    transform: "translate(-49.6999 -40.4001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.6999 86.8001C86.7397 86.8001 96.4999 77.1294 96.4999 65.2001C96.4999 53.2707 86.7397 43.6001 74.6999 43.6001C62.6601 43.6001 52.8999 53.2707 52.8999 65.2001C52.8999 77.1294 62.6601 86.8001 74.6999 86.8001Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMatchingTransaction);
export default __webpack_public_path__ + "static/media/NoMatchingTransaction.adeacd33c602862a891f5957ffdd8e31.svg";
export { ForwardRef as ReactComponent };